<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="container space-1">
  <div *ngIf="cart.items.length == 0" class="w-md-80 w-lg-50 text-center mx-md-auto">
    <figure id="iconEmptyCart" class="ie-height-111 max-width-15 mx-auto mb-3" style="">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 120 120" style="enable-background: new 0 0 120 120" xml:space="preserve" class="injected-svg js-svg-injector" data-parent="#iconEmptyCart">
        <style type="text/css">
          .icon-66-0 {
            fill: none;
            stroke: #bdc5d1;
          }
          .icon-66-1 {
            fill: #377dff;
          }
          .icon-66-2 {
            fill: #ffffff;
          }
          .icon-66-3 {
            fill: #bdc5d1;
          }
        </style>
        <polygon class="icon-66-0 fill-none stroke-gray-400" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="102.6,89.5 42.8,89.5 17.7,32.1 2.1,32.1 2.1,24.9 22.4,24.9 47.5,82.3 102.6,82.3 "></polygon>
        <path class="icon-66-1 fill-primary" d="M66.7,107.4c0,5.9-4.8,10.8-10.8,10.8s-10.8-4.8-10.8-10.8S50,96.7,55.9,96.7S66.7,101.5,66.7,107.4z"></path>
        <path class="icon-66-1 fill-primary" d="M102.6,107.4c0,5.9-4.8,10.8-10.8,10.8S81,113.4,81,107.4s4.8-10.8,10.8-10.8S102.6,101.5,102.6,107.4z"></path>
        <path class="icon-66-2 fill-white" d="M95.1,107.4c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3S95.1,105.6,95.1,107.4z"></path>
        <path class="icon-66-2 fill-white" d="M59.2,107.4c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3C57.7,104.2,59.2,105.6,59.2,107.4z"></path>
        <circle class="icon-66-3 fill-gray-400" opacity=".5" cx="95.1" cy="30.3" r="24.9"></circle>
        <circle class="icon-66-2 fill-white" opacity=".5" cx="91.8" cy="26.9" r="24.9"></circle>
        <path class="icon-66-1 fill-primary" d="M91.8,1.8C77.9,1.8,66.7,13,66.7,26.9S77.9,52,91.8,52s25.1-11.2,25.1-25.1S105.7,1.8,91.8,1.8z M104.5,34.5  l-5.1,5.1L91.8,32l-7.6,7.6l-5.1-5.1l7.6-7.6l-7.6-7.6l5.1-5.1l7.6,7.6l7.6-7.6l5.1,5.1l-7.6,7.6L104.5,34.5z"></path>
        <path class="icon-66-3 fill-gray-400" d="M91.8,60.8c-13.7,0-25.4-8.7-30-20.8c-0.2-0.4-0.6-0.7-1-0.7H39.6c-0.8,0-1.3,0.8-1,1.5L52,74.4  c0.2,0.4,0.6,0.7,1,0.7h48.7c0.5,0,0.9-0.3,1-0.7l6.7-16.7c0.4-1-0.7-1.9-1.6-1.4C103.2,59.2,97.7,60.8,91.8,60.8z"></path>
      </svg>
    </figure>
    <div class="mb-5">
      <h1 class="h3 font-weight-medium">Your cart is currently empty</h1>
      <p>Before proceed to checkout you must add some products to your shopping cart. You will find a lot of interesting products on our "Shop" page.</p>
    </div>
    <a class="btn btn-primary btn-pill transition-3d-hover px-5" [routerLink]="['../call-for-sponsors']">Start Shopping</a>
  </div>
  <div *ngIf="cart.items.length > 0" class="row">
    <div class="col-lg-8 mb-7 mb-lg-0">
      <!-- Title -->
      <div class="d-flex justify-content-between align-items-end border-bottom pb-3 mb-7">
        <h1 class="h4 mb-0">Shopping cart</h1>
        <span>{{ cart.totalItems }} items</span>
      </div>
      <!-- End Title -->

      <!-- Product Content -->
      <div *ngFor="let item of cart.items; let idx = index" class="border-bottom pb-5 mb-5">
        <div class="row">
          <div class="col-md-6 mb-3 mb-md-0">
            <div class="media">
              <div class="max-width-15 w-100 mr-3">
                <img class="img-fluid" src="/fetchimage?fileName={{ item.product.marketingSplash }}&mode=crop&width=300&height=180" [fallback]="'https://bxlimages.blob.core.windows.net/splash/noimage.png'"  />
              </div>
              <div class="media-body">
                <h2 class="h6">{{ item.product.title }}</h2>
                <div *ngFor="let addon of item.selectedAddons" class="text-secondary font-size-1 mb-1">
                  <span>Add-On: {{ addon.title }} </span>
                </div>
                <ng-container *ngIf="item.product.isBooth">
                  <div class="text-secondary font-size-1 mb-1">
                    <span>Booth: {{ item.variationName }}</span>
                  </div>
                  <div class="text-secondary font-size-1 mb-1">
                    <span><a (click)="editOnMap(item.product)" href="javascript:void(0)">Edit on map</a></span>
                  </div>
                </ng-container>
                <p class="text-danger">{{ item.errorMessage }}</p>
              </div>
            </div>
          </div>

          <div class="col-5 col-md-3 offset-md-1">
            <select class="custom-select custom-select-sm w-auto mb-3" [(ngModel)]="item.qty" (ngModelChange)="cart.serializeCart()" name="qty">
              <ng-container *ngIf="!item.product.isBooth">
                <option *ngFor="let f of [].constructor(item.product.remainingQuantity); let r = index" value="{{ r + 1 }}">{{ r + 1 }}</option>
              </ng-container>
              <ng-container *ngIf="item.product.isBooth">
                <option [value]="1">1</option>
              </ng-container>
            </select>

            <div class="d-block">
              <a class="text-secondary font-size-1 mb-1" href="javascript:void(0)" (click)="cart.remove(idx)">
                <span class="far fa-trash-alt mr-1"></span>
                <span>Remove</span>
              </a>
            </div>
          </div>

          <div class="col-6 col-md-2 text-md-right">
            <span class="font-weight-medium">{{ item.product.price * item.qty | currency: conference.sponsorCurrency }}</span>
          </div>
        </div>
      </div>
      <!-- End Product Content -->

      <div class="d-flex justify-content-end">
        <a [routerLink]="['../', homeRoute]">
          <small class="fas fa-arrow-left mr-1"></small>
          Continue shopping
        </a>
      </div>
    </div>

    <div class="col-lg-4">
      <div class="pl-lg-4">
        <!-- Order Summary -->
        <div class="border shadow-soft rounded p-5 mb-4">
          <!-- Title -->
          <div class="border-bottom pb-4 mb-4">
            <h2 class="h5 mb-0">Order summary</h2>
          </div>
          <!-- End Title -->

          <div class="border-bottom pb-4 mb-4">
            <div class="media align-items-center mb-3">
              <h3 class="text-secondary font-size-1 font-weight-normal mb-0 mr-3">Item subtotal ({{ cart.totalItems }})</h3>
              <div class="media-body text-right">
                <span class="font-weight-medium">{{ cart.cartTotal | currency: conference.sponsorCurrency }}</span>
              </div>
            </div>

            <div class="media align-items-center mb-3">
              <h4 class="text-secondary font-size-1 font-weight-normal mb-0 mr-3">Delivery</h4>
              <div class="media-body text-right">
                <span class="font-weight-medium">Electronic</span>
              </div>
            </div>
          </div>

          <div class="media align-items-center mb-4">
            <h4 class="text-secondary font-size-1 font-weight-normal mb-0 mr-3">Total</h4>
            <div class="media-body text-right">
              <span class="font-weight-medium">{{ cart.cartTotal | currency: conference.sponsorCurrency }}</span>
            </div>
          </div>

          <a class="btn btn-primary btn-pill btn-block transition-3d-hover" [routerLink]="['../checkout']">Checkout</a>
        </div>
        <!-- End Order Summary -->

        <!-- Accordion -->
        <!-- <div id="shopCartAccordion" class="accordion rounded shadow-soft mb-4">
          <div class="card rounded">
            <div class="card-header card-collapse" id="shopCartHeadingOne">
              <h3 class="mb-0">
                <button type="button" class="btn btn-link btn-block card-btn font-weight-medium collapsed" data-toggle="collapse" data-target="#shopCartOne" aria-expanded="false" aria-controls="shopCartOne">
                  Promo code?
                  <span class="far fa-question-circle text-secondary ml-1" data-container="body" data-toggle="popover" data-placement="top" data-trigger="hover" title="" data-content="Valid on full priced items only. Some products maybe excluded." data-original-title="Promo code"></span>
                </button>
              </h3>
            </div>
            <div id="shopCartOne" class="collapse" aria-labelledby="shopCartHeadingOne" data-parent="#shopCartAccordion">
              <form class="js-validate p-5" novalidate="novalidate">
                <div class="input-group input-group-pill mb-3">
                  <input type="text" class="form-control" name="name" placeholder="Promo code" aria-label="Promo code" />
                  <div class="input-group-append">
                    <button type="submit" class="btn btn-block btn-primary btn-pill">Apply</button>
                  </div>
                </div>
              </form>
            </div>
          </div>

        </div> -->
        <!-- End Accordion -->
      </div>
    </div>
  </div>
</div>
